// extracted by mini-css-extract-plugin
export default {"productCarousel":"h2-z"};